export const LOCAL_STORAGE_STAY_TUNED = 'stay_tuned' 
export const DEVICE_ID = 'device_id' 
export const ACCESS_TOKEN = 'access_token' 
export const FIREBASE_USER = 'firebase_user' 
export const SESSION = 'session' 
export const NAVIGATE_ROUTE = 'navigate_route' 